module.exports = __webpack_public_path__ + "img/icon-checkmark.cc94c152.svg";